import { Input } from "antd"; // Correct import from 'antd'
import { SearchOutlined } from "@ant-design/icons"; // Import search icon
import { useState } from "react";
import { usePaginationBezPrzekazania } from "../../../context/PaginationContextBezPrzekazania";
import {Button} from "antd";

const SearchInput = ({ placeholder = "Search...", onSearch }) => {
    const { pagination, setPagination } = usePaginationBezPrzekazania();
    const [value, setValue] = useState(JSON.parse(localStorage.getItem('search')) || '');

    const handleChange = (e) => {
        setValue(e.target.value);
    };

    const submitSearch = () => {
        setPagination({ ...pagination, search: value, current: 1 });
    };

    const handleSearch = () => {
        if (onSearch) {
            onSearch(value); // Trigger the search callback if provided
        }
        // Update the pagination search
        setPagination({ ...pagination, search: value, current: 1 });
    };

    const handleClear = () => {
        setValue('');
        if (onSearch) {
            onSearch('');
        }
        setPagination({ ...pagination, search: '', current: 1 });
    };

    return (
        <div style={{ display: 'flex', width: '100%' }} className="search-wrapper">
        <Input
            value={value} // Bind the input value to state
            defaultValue={value}
            onChange={handleChange}
            width='100%'
            disabled={pagination.loading}
            onPressEnter={submitSearch} // Trigger search on Enter key press
            addonBefore={<SearchOutlined onClick={handleChange} />} // Trigger search on icon click
            placeholder="Wyszukaj wpływ lub osobę"
            style={{
                borderRadius: '0px !important',
                maxWidth: '400px',
            }}
        />
        <Button onClick={handleSearch} disabled={pagination.loading} style={{height: '100%', borderLeft: 'none', borderRadius: '0'}}>Wyszukaj</Button>
        <Button onClick={handleClear} disabled={pagination.loading} style={{height: '100%', borderLeft: 'none', borderRadius: '0 2px 2px 0'}}>Wyczyść</Button>
        </div>
    );
};

export default SearchInput;